module.exports = __webpack_public_path__ + "img/banner-05.a9e27d87.jpg";